<template>
  <v-container fluid>
    <!-- Sidebar -->
    <SidebarNavigation />
    <v-card>
      <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab v-for="item in tabItems" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>

    <!-- contenct tab -->
    <v-card>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <!-- badge -->
          <v-row class="align-center">
            <div class="d-flex align-center ml-4">
              <span class="text-unread status-box">Belum dibaca</span>
              <v-badge
                v-if="total_unread"
                :content="total_unread"
                color="red"
                class="total-unread"
                inline
              ></v-badge>
            </div>
          </v-row>

          <!-- Table -->
          <v-row>
            <v-col>
              <v-data-table
                mobile-breakpoint="0"
                fixed-header
                dense
                class="elevation-5"
                :headers="tableHeaders"
                :items="approvalsList"
                :items-per-page.sync="pagination.itemsPerPage"
                :page.sync="pagination.page"
                :sort-by="pagination.sortBy"
                :sort-desc="pagination.sortDesc"
                :loading="isLoading"
                :server-items-length="totalApprovals"
                item-key="id"
                @update:page="updateQuery('page', $event)"
                @update:items-per-page="updateQuery('itemsPerPage', $event)"
                @update:sort-by="updateQuery('sortBy', $event)"
                @update:sort-desc="updateQuery('sortDesc', $event)"
              >
                <!-- Body untuk baris utama -->
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>
                        <span
                          v-if="item.is_unread"
                          class="text-unread"
                          @click="openDialogSuggestionDetail(item)"
                        >
                          {{ item.title }}
                        </span>
                        <span
                          v-else
                          class="text-lightgray"
                          @click="openDialogSuggestionDetail(item)"
                        >
                          {{ item.title }}
                        </span>
                      </td>
                      <td>{{ item.suggestion_category_name }}</td>
                      <td>
                        <div v-if="item.file_names">
                          <v-icon
                            v-for="(fileName, index) in item.file_names.split(
                              '|'
                            )"
                            :key="index"
                            color="primary"
                            @click="
                              downloadAttachment(item.suggestion_id, fileName)
                            "
                          >
                            <!-- Menampilkan ikon berdasarkan ekstensi fileName -->
                            <template v-if="fileName.slice(1) == '.xlsx'">
                              mdi-file-excel-outline
                            </template>

                            <template
                              v-else-if="
                                fileName.slice(1) == '.jpeg' ||
                                fileName.slice(1) == '.png' ||
                                fileName.slice(1) == '.jpeg' ||
                                fileName.slice(1) == '.jpg'
                              "
                            >
                              mdi-image
                            </template>
                            <template v-else-if="fileName.slice(1) == '.pdf'">
                              mdi-file-pdf-box
                            </template>
                            <template v-else>
                              mdi-file-download-outline
                            </template>
                          </v-icon>
                        </div>
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="item.action_history_approval === 't'"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click="openApprovalHistory(item.suggestion_id)"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          Tampilkan
                        </v-tooltip>
                      </td>
                      <td>
                        <div style="font-size: 12px">
                          {{ item.created_by_name }}
                        </div>
                        <div style="font-size: 12px">
                          {{ item.mst_division_name }}
                        </div>
                        <div style="font-size: 12px">{{ item.created_on }}</div>
                      </td>

                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              @click="openApprovalDialog('approve', item)"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon color="success">mdi-check</v-icon>
                            </v-btn>
                          </template>
                          Approve
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="red"
                              @click="openApprovalDialog('reject', item)"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                          Reject
                        </v-tooltip>

                        <v-tooltip
                          v-if="item.last_status === 'waiting approval'"
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              small
                              icon
                              color="warning"
                              @click="openDialogTbr(item)"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-skip-previous</v-icon>
                            </v-btn>
                          </template>
                          To Be Revised
                        </v-tooltip>

                        <v-tooltip v-if="user.mst_division_id === 5" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="primary"
                              @click="
                                openApprovalDialog('need to analysis', item)
                              "
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon color="orange"
                                >mdi mdi-backup-restore</v-icon
                              >
                            </v-btn>
                          </template>
                          Need To Analysis
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- content tab 2-->
        <v-tab-item> </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- suggestion Dialog -->
    <v-dialog v-model="isDialogOpen" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValid">
            <v-radio-group
              v-show="isShowQuickWin"
              v-model="isQuickWinOptionsSelected"
              label="Idea"
            >
              <v-radio label="Quick Win" value="1"></v-radio>
              <v-radio label="Project Management" value="0"></v-radio>
            </v-radio-group>
            <v-textarea
              v-model="approvalFormData.comments"
              label="Catatan"
              required
              :rules="[(v) => !!v || 'Catatan tidak boleh kosong !']"
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpen = false">Cancel</v-btn>
          <v-btn color="primary" :disabled="!isFormValid" @click="submit"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Riwayat Persetujuan -->
    <v-dialog v-model="isDialogOpenApprovalHistory" max-width="700px">
      <v-card>
        <v-card-title class="headline">Riwayat Persetujuan</v-card-title>
        <v-data-table
          mobile-breakpoint="0"
          :headers="tableHeadersApproval"
          :items="approvalHistoryList"
          class="elevation-1"
        >
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- suggestion detail -->
    <v-dialog v-model="isDialogOpenSuggestionDetail" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValid">
            <v-autocomplete
              v-model="approvalFormData.suggestion_category_id"
              :items="suggestionCategoryOptions"
              item-text="name"
              item-value="id"
              label="Kategori"
              required
              readonly
              :loading="isSuggestionCategoryLoading"
              :search-input.sync="suggestionCategorySearchQuery"
              @update:search-input="fetchSuggestionCaretgory"
            />
            <v-text-field
              v-model="approvalFormData.title"
              label="Judul"
              readonly
              required
            ></v-text-field>
            <v-textarea
              v-model="approvalFormData.description"
              label="Latar Belakang / Uraian Masalah"
              required
              readonly
              autocomplete="new-description"
            ></v-textarea>
            <v-textarea
              v-model="approvalFormData.suggestions"
              label="Solusi"
              readonly
              required
            ></v-textarea>

            <v-text-field
              v-model="formattedBenefitDetail"
              label="Potensi Benefit"
              type="text"
              readonly
            >
            </v-text-field>

            <v-textarea
              v-model="approvalFormData.noted"
              label="Keterangan Biaya"
              readonly
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenSuggestionDetail = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- to be revised -->
    <v-dialog v-model="isDialogOpenTbr" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Konfirmasi</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text
              >Yakin ide dengan judul "{{ titleSuggestion }}" To Be Revised
              ?</v-text
            >
            <v-text-field
              v-model="note"
              label="Catatan"
              required
              :rules="[(v) => !!v || 'Catatan tidak boleh kosong !']"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenTbr = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="submitTbr">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      awsObjectUrl: process.env.VUE_APP_AWS_OBJECT_URL,
      awsPath: process.env.VUE_APP_AWS_PATH,
      isShowQuickWin: false,
      isQuickWinOptionsSelected: "1",
      selectedSuggestion: {},
      mode: null,
      dialogVisible: false,
      dialogTitle: "",
      suggestionCategoryOptions: null,
      suggestionDetailCategoryOptions: null,
      isSuggestionCategoryLoading: false,
      suggestionCategorySearchQuery: "",
      visibleUpload: true,
      tab: 1,
      tabItems: ["Persetujuan"],
      approvalsList: [],
      approvalHistoryList: [],
      isLoading: false,
      isDialogOpen: false,
      isDialogOpenApprovalHistory: false,
      isDialogOpenSuggestionDetail: false,
      isDialogOpenTbr: false,
      dialogMode: "approve",
      isFormValid: false,
      approvalFormData: {
        comments: "",
        status: "",
      },
      tableHeaders: [
        { text: "Judul", align: "center", value: "title" },
        { text: "Kategori", align: "center", value: "category" },
        {
          text: "Lampiran Perhitungan",
          align: "center",
          value: "lampiran_perhitungan",
        },
        {
          text: "Riwayat Persetujuan",

          align: "center",
          value: "history_approval",
        },
        { text: "Dibuat Oleh", align: "center", value: "id" },
        { text: "Aksi", align: "center", value: "actions", sortable: false },
      ],
      tableHeadersApproval: [
        { text: "Name", align: "center", value: "step_name" },
        { text: "Status", align: "center", value: "status" },
        { text: "Catatan", align: "center", value: "comments" },
        { text: "Di Setujui Oleh", align: "center", value: "created_by_name" },
        { text: "Tanggal", align: "center", value: "created_on" },
      ],
      totalApprovals: 0,
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        search: "",
      },
      suggestionDetail: {
        id: null,
        suggestion_category_id: null,
        title: "",
        description: "",
        suggestions: "",
        benefit: 0,
        noted: "",
      },
      selectedSuggestionCategoryId: null,
      note: "",
      suggestionId: null,
      is_unread: 1,
      titleSuggestion: null,
      stepId: null,
      total_unread: 0,
    };
  },
  methods: {
    fetchSuggestionCaretgory() {
      this.isSuggestionCategoryLoading = true;
      api
        .get("/suggestions-categories")
        .then(({ data }) => {
          this.suggestionCategoryOptions = data.data.data;
          this.suggestionDetailCategoryOptions = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching roles:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
          this.isSuggestionCategoryLoading = false;
        });
    },
    async fetchApproval() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.search,
        sortBy: query.sortBy || this.pagination.sortBy || "name",
        sortDesc: query.sortDesc || this.pagination.sortDesc || true,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
      };

      await api
        .get("/approvals", { params })
        .then(({ data }) => {
          // console.log(data);
          this.approvalsList = data.data.data;
          this.totalApprovals = data.data.total;
          this.total_unread = data.data.total_unread;
          store.commit("setTotalApprovals", data.data.total_unread);
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    openApprovalDialog(mode, params = null) {
      // console.log(params);
      // return;
      if (mode === "approve" && this.user.mst_division_id === 5) {
        this.isShowQuickWin = true;
      } else {
        this.isShowQuickWin = false;
        this.isQuickWinOptionsSelected = "1";
      }
      this.mode = mode;
      this.dialogTitle =
        mode.charAt(0).toUpperCase() + mode.slice(1).toLowerCase();
      this.approvalFormData = { ...params };
      this.isDialogOpen = true;
      this.isSuggestionCategoryLoading = false;
    },

    openApprovalHistory(id) {
      api
        .get(`/approvals/by-suggestion-id/${id}`)
        .then(({ data }) => {
          this.approvalHistoryList = data.data;
          this.isDialogOpenApprovalHistory = true;
        })
        .catch((error) => {
          this.approvalHistoryList = [];
          this.isDialogOpenApprovalHistory = true;
          console.error("Error fetching position:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    openDialogSuggestionDetail(params = null) {
      this.dialogTitle = "Detail Suggestion";
      this.approvalFormData = { ...params };
      this.isSuggestionCategoryLoading = false;
      this.selectedSuggestionCategoryId = params.suggestion_category_id;
      this.isDialogOpenSuggestionDetail = true;
      this.suggestionId = params.suggestion_id;
      this.submitRead();
    },

    async openDialogTbr(params) {
      this.suggestionId = params.suggestion_id;
      this.stepId = params.step_id;
      this.titleSuggestion = params.title;
      this.isDialogOpenTbr = true;
    },
    downloadAttachment(id, fileName) {
      // console.log(pathName);
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/calculation/${id}/${fileName}`,
        "_blank"
      );
    },

    submit() {
      store.dispatch("showLoading");
      this.approvalFormData.status = this.mode;

      // Pastikan hanya id dari role yang dikirimkan
      const payload = { ...this.approvalFormData };
      payload.is_quick_win = this.isQuickWinOptionsSelected;

      // console.log(payload);

      api
        .post("/approvals", payload)
        .then((response) => {
          // Mengambil pesan dari backend
          const message = response.data.message; // Pesan dari backend

          // Menampilkan pesan dengan status "success" (hijau)
          this.fetchApproval(); // Fungsi untuk mengambil data karyawan terbaru
          this.isDialogOpen = false;

          // Memanggil action Vuex untuk menampilkan snackbar dengan status success (hijau)
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save suggestion!"; // Pesan default jika error

          if (error.response) {
            // Jika ada respons error dari backend
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message; // Pesan error default
          }

          // Menampilkan snackbar dengan status error (merah)
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    submitTbr() {
      store.dispatch("showLoading");

      if (!this.note) {
        store.dispatch("triggerSnackbar", {
          message: "Catatan tidak boleh kosong !",
          isSuccess: false,
        });
        store.dispatch("hideLoading");
        return;
      }

      const payload = {
        suggestion_id: this.suggestionId,
        note: this.note,
        step_id: this.stepId,
      };

      // console.log(payload);

      api
        .post("/approvals/update/to-be-revised", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchApproval();
          this.isDialogOpenTbr = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.note = "";
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    submitRead() {
      const payload = {
        suggestion_id: this.suggestionId,
        is_unread: 0,
      };

      // console.log(payload);
      api
        .post("/approvals/update/read", payload)
        .then(() => {
          // const message = response.data.message;
          this.fetchApproval();
          // store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to read tittle!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    updatePagination(query) {
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
  },
  watch: {
    pagination: {
      handler: "fetchApproval",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
  mounted() {
    store.commit("setTitle", "Persetujuan");
    this.fetchApproval();
    this.updatePagination(this.$route.query);
  },
  computed: {
    user() {
      return store.getters["user/getUser"] || {}; // get Data User
    },
    formattedBenefitDetail: {
      get() {
        return new Intl.NumberFormat("id-ID").format(
          this.approvalFormData.benefit
        );
      },
      set(value) {
        // Hapus titik saat input berubah, agar tetap bisa menyimpan angka asli
        this.approvalFormData.benefit = parseInt(value.replace(/\./g, "")) || 0;
      },
    },
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(3),
td:nth-child(4),
td:nth-child(5),
td:nth-child(6) {
  text-align: center;
}

.text-lightgray {
  background-color: #ffffff; /* abu-abu terang */
  cursor: pointer;
  padding: 5px;
}

.text-unread {
  background-color: #bcf8d4; /* abu-abu terang */
  cursor: pointer;
  padding: 5px;
}
.status-box {
  margin-top: 30px;
  padding: 2px 6px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 0.65rem;
}
.total-unread {
  position: absolute;
  left: 70px;
  transform: translatey(0px);
}
</style>
